// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"c2f6e55d","107":"d9bcd202","114":"a92b2f0f","130":"de931d97","213":"e43806e5","217":"ccafb8ac","233":"bfd562e3","449":"6d81c68e","466":"ffe9b7da","510":"acd023ec","634":"5d3c2693","718":"07c64dd0","791":"6ce16201"}[chunkId] + ".chunk.js";
};